// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".strike[data-v-c9fb21a0]{display:block;overflow:hidden;text-align:center;white-space:nowrap}.strike>span[data-v-c9fb21a0]{display:inline-block;position:relative}.strike>span[data-v-c9fb21a0]:after,.strike>span[data-v-c9fb21a0]:before{background:#eaeaea;content:\"\";height:1px;position:absolute;top:50%;width:9999px}.strike>span[data-v-c9fb21a0]:before{margin-right:15px;right:100%}.strike>span[data-v-c9fb21a0]:after{left:100%;margin-left:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
